/* =============================================================================
   Paradise Partners, live store attribution
   A visitor arriving on any URL with ?ref=CODE has that code held permanently:
   in localStorage, which has no expiry, and in a first party cookie that is
   renewed on every visit. The code is written onto the Shopify cart as an order
   attribute and carried into checkout as a discount code. Nothing here depends
   on another script, so the link works on every template.
   ========================================================================== */
(function () {
  'use strict';

  var COOKIE = 'ppp_ref';
  var COOKIE_AT = 'ppp_ref_at';
  var COOKIE_BAR = 'ppp_ref_bar';
  /* Attribution does not expire. Browsers cap a cookie at roughly four hundred
     days, so the cookie is renewed on every visit and localStorage holds the
     durable copy. Together they outlive any single cookie lifetime. */
  var COOKIE_DAYS = 390;
  var STORE_KEY = 'ppp_ref';
  var STORE_AT_KEY = 'ppp_ref_at';

  /* One shared shopper discount rather than one code per partner. Anyone can
     invent a partner code and start posting links straight away, and the ten
     percent still applies, because attribution rides on the stored code and the
     order attribute rather than on the discount itself.

     The code is set in Shopify not to combine with any other discount, and the
     helpers below never append it to a link or a form that already carries a
     discount, so it can never be stacked on top of another offer. */
  var SHOPPER_DISCOUNT = 'FLUFF10';

  /* -------------------------------------------------------------- cookies */
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function writeCookie(name, value, days) {
    var bits = [name + '=' + encodeURIComponent(value), 'path=/', 'SameSite=Lax'];
    if (days) bits.push('max-age=' + Math.round(days * 86400));
    if (location.protocol === 'https:') bits.push('Secure');
    document.cookie = bits.join(';');
  }

  /* -------------------------------------------------------- durable store */
  function readStore(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }
  function writeStore(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function normalise(v) {
    return String(v || '')
      .toUpperCase()
      .replace(/[^A-Z0-9_-]/g, '')
      .slice(0, 24);
  }

  /* Reads the stored code and renews it, so attribution never lapses. The
     cookie and localStorage back each other up: whichever one survives a
     browser clean up restores the other. */
  function code() {
    var c = readCookie(COOKIE) || readStore(STORE_KEY);
    if (!c) return '';
    c = normalise(c);
    if (!c) return '';
    var at = Number(readCookie(COOKIE_AT) || readStore(STORE_AT_KEY) || Date.now());
    persist(c, at);
    return c;
  }

  function persist(c, at) {
    writeCookie(COOKIE, c, COOKIE_DAYS);
    writeCookie(COOKIE_AT, String(at), COOKIE_DAYS);
    writeStore(STORE_KEY, c);
    writeStore(STORE_AT_KEY, String(at));
  }

  /* Kept for the page markup, which shows how long attribution lasts. */
  function daysSince() {
    var at = Number(readCookie(COOKIE_AT) || readStore(STORE_AT_KEY) || 0);
    if (!at) return 0;
    return Math.max(0, Math.floor((Date.now() - at) / 864e5));
  }

  /* -------------------------------------------------------------- capture */
  var fresh = false;
  function capture() {
    var p = new URLSearchParams(location.search);
    var raw = p.get('ref') || p.get('via') || p.get('partner');
    if (!raw) return;
    var c = normalise(raw);
    if (!c) return;
    var had = readCookie(COOKIE) || readStore(STORE_KEY);
    fresh = had !== c;
    persist(c, fresh ? Date.now() : Number(readCookie(COOKIE_AT) || readStore(STORE_AT_KEY) || Date.now()));
    if (fresh) writeCookie(COOKIE_BAR, '', -1);
    // Tidy the address bar so a shared screenshot does not leak the code.
    p.delete('ref');
    p.delete('via');
    p.delete('partner');
    var q = p.toString();
    history.replaceState({}, '', location.pathname + (q ? '?' + q : '') + location.hash);
  }

  /* --------------------------------------------------------- cart tagging */
  function tagCart(c) {
    if (!c || !window.fetch) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          Referral: c,
          'Referral captured': new Date().toISOString().slice(0, 10)
        }
      })
    })['catch'](function () {});
  }

  /* ------------------------------------------------------ checkout tagging */
  function tagLinks(c) {
    if (!c || !SHOPPER_DISCOUNT) return;
    // A shopper who already arrived on a discount link keeps that offer. The
    // partner code is never added on top of one.
    if (location.search.indexOf('discount=') > -1 || location.pathname.indexOf('/discount/') === 0) return;
    var links = document.querySelectorAll('a[href*="/checkout"], a[href*="/cart"], a[href*="/discount/"]');
    Array.prototype.forEach.call(links, function (a) {
      var h = a.getAttribute('href') || '';
      if (!h || h.charAt(0) === '#' || h.indexOf('discount=') > -1) return;
      a.setAttribute(
        'href',
        h + (h.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(SHOPPER_DISCOUNT)
      );
    });
    // Checkout submitted from a cart form carries the discount as a hidden field.
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart"]'), function (f) {
      if (f.querySelector('[name="discount"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'discount';
      i.value = SHOPPER_DISCOUNT;
      f.appendChild(i);
    });
  }

  /* ------------------------------------------------------------ credit bar */
  function bar(c) {
    if (document.querySelector('[data-ppp-refbar]')) return;
    if (!fresh && readCookie(COOKIE_BAR) === c) return;
    writeCookie(COOKIE_BAR, c, 0);

    var el = document.createElement('div');
    el.setAttribute('data-ppp-refbar', '');
    el.style.cssText =
      'position:fixed;left:50%;bottom:16px;transform:translateX(-50%) translateY(150%);z-index:9000;' +
      'display:flex;align-items:center;gap:10px;padding:10px 12px 10px 18px;border-radius:999px;' +
      'background:rgba(255,253,249,.96);border:1px solid rgba(74,59,52,.16);' +
      'box-shadow:0 14px 32px rgba(74,59,52,.2);color:#4a3b34;font-size:.84rem;' +
      'font-family:inherit;max-width:calc(100% - 32px);' +
      'transition:transform 520ms cubic-bezier(.16,1,.3,1)';
    el.innerHTML =
      '<span>Credited to <b style="color:#8a3a52">' +
      c +
      '</b> for good. Ten percent comes off at checkout.</span>' +
      '<button type="button" aria-label="Dismiss partner credit" ' +
      'style="border:0;background:rgba(74,59,52,.08);width:28px;height:28px;border-radius:50%;' +
      'cursor:pointer;color:inherit;line-height:1;font-size:15px">&times;</button>';
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.style.transform = 'translateX(-50%) translateY(0)';
    });
    function hide() {
      el.style.transform = 'translateX(-50%) translateY(180%)';
      setTimeout(function () {
        el.remove();
      }, 560);
    }
    el.querySelector('button').addEventListener('click', hide);
    setTimeout(function () {
      if (el.isConnected) hide();
    }, fresh ? 9000 : 6000);
  }

  /* -------------------------------------------------------- link builder */
  function builder() {
    var root = document.querySelector('[data-ppp-builder]');
    if (!root) return;
    var input = root.querySelector('[data-ppp-code]');
    var target = root.querySelector('[data-ppp-target]');
    var out = root.querySelector('[data-ppp-link]');
    var copy = root.querySelector('[data-ppp-copy]');
    var status = root.querySelector('[data-ppp-status]');
    var kpiCode = root.querySelector('[data-ppp-active]');
    var kpiDays = root.querySelector('[data-ppp-days]');

    function build() {
      var c = normalise(input ? input.value : '');
      var path = target ? target.value : '/';
      var url = location.origin + path + (c ? (path.indexOf('?') > -1 ? '&' : '?') + 'ref=' + c : '');
      if (out) out.value = url;
      if (status) {
        status.textContent = c
          ? 'Ready. Every visit through this link is credited to ' + c + ', and the credit does not expire.'
          : 'Enter a partner code to build a link.';
      }
      return url;
    }
    if (input) {
      input.addEventListener('input', build);
      // A visitor who typed a code into the invitation band on any page arrives
      // here with ?code= set, so the builder opens already filled in.
      var wanted = normalise(new URLSearchParams(location.search).get('code') || '');
      if (!input.value && wanted) input.value = wanted;
      if (!input.value && code()) input.value = code();
    }
    if (target) target.addEventListener('change', build);
    if (copy) {
      copy.addEventListener('click', function () {
        var url = build();
        var done = function () {
          copy.textContent = 'Copied';
          setTimeout(function () {
            copy.textContent = 'Copy link';
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else if (out) {
          out.select();
          try {
            document.execCommand('copy');
          } catch (e) {}
          done();
        }
      });
    }
    if (kpiCode) kpiCode.textContent = code() || 'None';
    if (kpiDays) kpiDays.textContent = 'Permanent';
    build();
  }

  window.ParadisePartners = {
    code: code,
    normalise: normalise,
    permanent: true,
    daysSince: daysSince,
    discount: SHOPPER_DISCOUNT
  };

  function boot() {
    capture();
    var c = code();
    if (c) {
      bar(c);
      tagCart(c);
      setTimeout(function () {
        tagLinks(c);
      }, 80);
    }
    builder();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
